import { combineReducers } from '@reduxjs/toolkit';
import { region } from "./slices/region";
import { menu } from "./slices/menu";
import { search } from "./slices/search";
import { cart } from "./slices/cart";
import { HeaderThemeView, layout } from "./slices/layout";
export { HeaderThemeView };
export var headerSlices = {
  common: function common() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return state;
  },
  region: region,
  menu: menu,
  search: search,
  cart: cart,
  layout: layout
};
export var headerReducer = combineReducers(headerSlices);